import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectTrigger, SelectValue } from "@/components/ui/select";
import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SelectInputFieldProps extends Omit<FormFieldComponentProps, "ref"> {
  numberValue?: boolean;
  ref?: React.Ref<HTMLDivElement>;
  triggerClassName?: string;
  /** Optional callback called when the select value changes */
  onChange?: () => void;
};

const SelectInputField = (props: SelectInputFieldProps): JSX.Element => {
  const {
    form,
    name,
    label,
    children,
    numberValue,
    disabled,
    onKeyDown,
    className,
    defaultValue,
    ref,
    triggerClassName,
    onChange: customOnChange,
  } = props;

  const { t } = useTranslation(["common"]);

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(className ?? "form-item")} ref={ref} onKeyDown={onKeyDown}>
          {label && <FormLabel>{label}</FormLabel>}
          <Select
            disabled={disabled}
            onValueChange={(value) => {
              field.onChange(numberValue ? Number(value) : value);
              customOnChange?.();
            }}
            value={field.value ?? defaultValue ?? ""}
          >
            <FormControl ref={ref}>
              <SelectTrigger className={triggerClassName}>
                <SelectValue placeholder={`${t("forms.selectplaceholder", { name: label })}`} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>{children}</SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default SelectInputField;
